import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Mapea tu estado',
    desc: "Realiza el Test de Señales de Brecha para mapear tu estado actual de 'hambre celular'."
  }, {
    num: '02',
    title: 'Satura tus depósitos',
    desc: 'Sigue el cronograma de 21 días de saturación nutricional diseñado para llenar tus depósitos.'
  }, {
    num: '03',
    title: 'Recupera tu claridad',
    desc: 'Observa cómo desaparece el bostezo de las 3:00 PM y recuperas la claridad mental que creías perdida.'
  }];
  return <section className="py-24 px-4 bg-sage" data-id="element-199">
      <div className="max-w-5xl mx-auto" data-id="element-200">
        <FadeIn data-id="element-201">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest mb-16 text-center" data-id="element-202">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-203">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-forest/20 z-0" data-id="element-204" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-205">
              <div className="flex flex-col items-center text-center" data-id="element-206">
                <div className="w-24 h-24 bg-forest text-amber-light rounded-full flex items-center justify-center text-3xl font-serif font-bold mb-6 shadow-xl border-4 border-sage" data-id="element-207">
                  {step.num}
                </div>
                <h3 className="font-bold text-xl text-forest mb-3" data-id="element-208">
                  {step.title}
                </h3>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-209">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}